module.exports = __webpack_public_path__ + "static/media/img_2.a0c19d27.png";